"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.incrementTimestampMsByS3TimeLevel = exports.s3TimeKeyToDate = exports.incrementFromTo = exports.incrementS3TimeKey = exports.getCommonLevel = exports.getS3TimeKeys = exports.getS3TimeKey = exports.getS3TimeKeyPrefix = exports.getS3TimeKeyElements = exports.S3TimeKeyStrategy = exports.S3TimeKeyLevel = void 0;
exports.s3TimeKeyIncrementor = s3TimeKeyIncrementor;
const constants_1 = require("../../../constants");
const debug_1 = require("../../lambda/debug");
const __1 = require("..");
const debug = debug_1.DEBUG_OVERRIDE || (debug_1.NOT_CLOUD && false);
var S3TimeKeyLevel;
(function (S3TimeKeyLevel) {
    S3TimeKeyLevel[S3TimeKeyLevel["YEAR"] = 0] = "YEAR";
    S3TimeKeyLevel[S3TimeKeyLevel["MONTH"] = 1] = "MONTH";
    S3TimeKeyLevel[S3TimeKeyLevel["DAY"] = 2] = "DAY";
    S3TimeKeyLevel[S3TimeKeyLevel["HOUR"] = 3] = "HOUR";
    S3TimeKeyLevel[S3TimeKeyLevel["MINUTE"] = 4] = "MINUTE";
    S3TimeKeyLevel[S3TimeKeyLevel["SECOND"] = 5] = "SECOND";
    S3TimeKeyLevel[S3TimeKeyLevel["MILLISECOND"] = 6] = "MILLISECOND";
})(S3TimeKeyLevel || (exports.S3TimeKeyLevel = S3TimeKeyLevel = {}));
var S3TimeKeyStrategy;
(function (S3TimeKeyStrategy) {
    S3TimeKeyStrategy["OBJECT_TIME"] = "OBJECT_TIME";
    S3TimeKeyStrategy["TIME_OBJECT"] = "TIME_OBJECT";
})(S3TimeKeyStrategy || (exports.S3TimeKeyStrategy = S3TimeKeyStrategy = {}));
const S3FolderSeperator = '/';
/**
 * pad single digits to length 2 with leading zero
 */
const psd = (x) => x.toString().padStart(2, '0');
/**
 * pad single digits to length 3 with leading zero
 */
const psd3 = (x) => x.toString().padStart(3, '0');
/** returns array of date elements in form [ y, m, d, h, min, s, ms ] */
const getS3TimeKeyElements = (date) => {
    const [y, m, d, h, min, s, ms] = [
        date.getUTCFullYear(),
        date.getUTCMonth() + 1,
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds(),
        date.getUTCMilliseconds(),
    ];
    const timeKeyElements = [y.toString(), psd(m), psd(d), psd(h), psd(min), psd(s), psd3(ms)];
    return timeKeyElements;
};
exports.getS3TimeKeyElements = getS3TimeKeyElements;
const getS3TimeKeyPrefix = ({ timestamp, s3TimeKeyLevel = S3TimeKeyLevel.DAY }) => {
    const date = timestamp ? new Date(timestamp) : new Date();
    return (0, exports.getS3TimeKeyElements)(date)
        .slice(0, s3TimeKeyLevel + 1)
        .join(S3FolderSeperator);
};
exports.getS3TimeKeyPrefix = getS3TimeKeyPrefix;
const getS3TimeKey = ({ object, timestamp, s3TimeKeyLevel = S3TimeKeyLevel.DAY, s3TimeKeyStrategy = S3TimeKeyStrategy.OBJECT_TIME, }) => {
    const timeKey = (0, exports.getS3TimeKeyPrefix)({ timestamp, s3TimeKeyLevel });
    const objectKey = [object.type, object.id].join(S3FolderSeperator);
    return s3TimeKeyStrategy === S3TimeKeyStrategy.OBJECT_TIME ? objectKey + S3FolderSeperator + timeKey : timeKey + S3FolderSeperator + objectKey;
};
exports.getS3TimeKey = getS3TimeKey;
const getS3TimeKeys = (s3TimeLevel, startIn, endIn) => {
    const start = (0, exports.getS3TimeKeyElements)(new Date(startIn.unix() * constants_1.Milliseconds.SECOND));
    const end = (0, exports.getS3TimeKeyElements)(new Date(endIn.unix() * constants_1.Milliseconds.SECOND));
    return (0, exports.incrementFromTo)({ start, end, level: s3TimeLevel, inc: 1 });
};
exports.getS3TimeKeys = getS3TimeKeys;
// ignoring days in month, days and months need to include basis and start from 1
const bN = [3000, 13, 32, 24, 60, 60, 1000];
const b0 = [0, 1, 1, 0, 0, 0, 0];
const getDaysInMonth = (keyIn) => {
    const date = new Date(Date.UTC(parseInt(keyIn[0]), parseInt(keyIn[1])));
    const daysInMonth = (0, __1.daysInLastUTCMonth)(date.valueOf());
    debug && console.log(`days in month ${keyIn[2]}: ${daysInMonth}`, date.toString());
    return daysInMonth;
};
const getCommonLevel = (start, end) => {
    let commonLevel = undefined;
    for (let [i, startEl] of start.entries()) {
        const endEl = end[i];
        if (startEl === endEl) {
            commonLevel = i;
        }
        else {
            break; // must break otherwise can match on lower order fields
        }
    }
    return commonLevel;
};
exports.getCommonLevel = getCommonLevel;
/**
 *
 * @param keyIn the full key to increment
 * @param level the level at which increments should happen
 * @param inc the number of increments at the level to increment by. This is NOT millisconds, it is the number of units of level
 * @returns
 */
const incrementS3TimeKey = (keyIn, level, inc = 1) => {
    const key = [...keyIn]; // spread otherwise will mutate
    const xnp = parseInt(key[level]) + inc; // raw accumated value
    const max = level === S3TimeKeyLevel.DAY ? getDaysInMonth(keyIn) + 1 : bN[level]; // when to rollover, at max div should be > 0, mod should be 0 or more
    const div = Math.floor(xnp / max); // dividend
    const mod = xnp % max; // modulus
    const accumulation = b0[level] === 1 && div > 0 ? b0[level] + mod : mod; // if rollover ( a > 0 ) and either Month or Day, start at 1
    debug && console.log({ level, parsedInt: parseInt(key[level]), key, max, xnp, a: div, b: mod });
    key[level] = level === S3TimeKeyLevel.MILLISECOND ? psd3(accumulation) : psd(accumulation);
    if (div > 0) {
        debug && console.log(`incremeting ${level - 1}, by ${div}`);
        return (0, exports.incrementS3TimeKey)(key, level - 1, div);
    }
    else {
        return key;
    }
};
exports.incrementS3TimeKey = incrementS3TimeKey;
/** returns each key that covers the start to end time.
 */
const incrementFromTo = ({ start, end, level, inc = 1 }) => {
    const keys = [start];
    let key = start;
    let isBetween = true;
    debug && console.log({ start, end, level, inc });
    do {
        key = (0, exports.incrementS3TimeKey)(key, level, inc);
        isBetween = key.join() <= end.join();
        isBetween && keys.push(key);
        debug && !isBetween && console.log({ isBetween, key, end });
    } while (isBetween);
    return keys;
};
exports.incrementFromTo = incrementFromTo;
/** yield incremented key elements, with the first being the start element (ie inclusive) */
function* s3TimeKeyIncrementor({ start, level, inc }) {
    let current = start;
    while (2 + 2 !== 5) {
        yield current;
        const next = (0, exports.incrementS3TimeKey)(current, level, inc);
        current = next;
    }
    return current;
}
const s3TimeKeyToDate = (s3TimeKey) => {
    const diff = 7 - s3TimeKey.length;
    for (let i = 0; i < diff; i++)
        s3TimeKey.push('00');
    const [y, m, d, h, min, s, ms] = s3TimeKey.map((x) => (x ? parseInt(x) : 0));
    const date = new Date();
    date.setUTCFullYear(y);
    date.setUTCMonth(m - 1);
    date.setUTCDate(d);
    date.setUTCHours(h);
    date.setUTCMinutes(min);
    date.setUTCSeconds(s);
    date.setUTCMilliseconds(ms);
    return date;
};
exports.s3TimeKeyToDate = s3TimeKeyToDate;
const incrementTimestampMsByS3TimeLevel = (timestampMs, s3TimeKeyLevel) => {
    const date = new Date(timestampMs);
    if (s3TimeKeyLevel === S3TimeKeyLevel.DAY) {
        date.setUTCDate(date.getUTCDate() + 1);
    }
    else if (s3TimeKeyLevel === S3TimeKeyLevel.HOUR) {
        date.setUTCHours(date.getUTCHours() + 1);
    }
    else if (s3TimeKeyLevel === S3TimeKeyLevel.MILLISECOND) {
        date.setUTCMilliseconds(date.getUTCMilliseconds() + 1);
    }
    else if (s3TimeKeyLevel === S3TimeKeyLevel.MINUTE) {
        date.setUTCMinutes(date.getUTCMinutes() + 1);
    }
    else if (s3TimeKeyLevel === S3TimeKeyLevel.SECOND) {
        date.setUTCSeconds(date.getUTCSeconds() + 1);
    }
    else if (s3TimeKeyLevel === S3TimeKeyLevel.MONTH) {
        date.setUTCMonth(date.getUTCMonth() + 1);
    }
    else if (s3TimeKeyLevel === S3TimeKeyLevel.YEAR) {
        date.setUTCFullYear(date.getUTCFullYear() + 1);
    }
    return date.valueOf();
};
exports.incrementTimestampMsByS3TimeLevel = incrementTimestampMsByS3TimeLevel;
